<template>
  <div>
    <label
      class="label"
      :for="id"
    >
      {{ error ? `*${label}` : label }}
      <span
        v-if="hint"
        class="hint"
      >{{ hint }}</span>
    </label>
    <div
      class="input-container"
      :class="loading ? 'input-container--loading' : ''"
    >
      <the-mask
        v-if="mask"
        :id="id"
        class="input"
        :class="{ 'input--error': !!errorMessage }"
        :mask="mask"
        :name="id"
        :type="type"
        v-bind="$attrs"
        :value="value"
        :aria-describedby="errorMessage ? id+'-error' : undefined"
        :aria-invalid="!!errorMessage"
        @input="handleMaskInput"
        v-on="getListeners"
      />
      <input
        v-else
        :id="id"
        class="input"
        :class="{ 'input--error': !!errorMessage }"
        :name="id"
        :type="type"
        v-bind="$attrs"
        :value="value"
        :aria-describedby="errorMessage ? id+'-error' : undefined"
        :aria-invalid="!!errorMessage"
        @input="handleInput"
        v-on="getListeners"
      >
    </div>
    <transition name="slide-down">
      <p
        v-if="errorMessage"
        :id="id+'-error'"
        class="form__error"
        v-html="errorMessage"
      />
    </transition>
  </div>
</template>
<script>
import { TheMask } from 'vue-the-mask';

export default {
  components: { TheMask },
  inheritAttrs: false,
  props: {
    id: { type: String, required: true },
    value: String,
    label: { type: String, required: true },
    errorCode: String,
    error: { type: String, default: undefined },
    hint: { type: String, default: undefined },
    loading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    mask: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    getListeners() {
      const { input, ...others } = this.$listeners;
      return { ...others };
    },
    errorMessage() {
      if (this.errorCode
        && this.$store.state.order.errorList
        && this.$store.state.order.errorList.includes(this.errorCode)) {
        return 'Please update this field to finish signing up';
      }
      if (this.error) {
        return this.error;
      }
      return null;
    },
  },
  methods: {
    handleMaskInput(value) {
      this.$emit('input', value);
    },
    handleInput(event) {
      this.$emit('input', event.target.value);
    },
  },
};
</script>
